var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33.66,
    height: 38.768,
    viewBox: "0 0 33.66 38.768",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_293",
    "data-name": "Rectangle 293",
    width: 33.66,
    height: 38.768,
    fill: "#99e7ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_386",
    "data-name": "Groupe 386",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_346",
    "data-name": "Groupe 346",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2834",
    "data-name": "Trac\\xE9 2834",
    d: "M12.229,10.354a10.377,10.377,0,1,1,10.337,10.38,10.386,10.386,0,0,1-10.337-10.38M22.613,2.706a7.661,7.661,0,1,0,7.665,7.663,7.681,7.681,0,0,0-7.665-7.663",
    transform: "translate(-5.779 0)",
    fill: "#99e7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2835",
    "data-name": "Trac\\xE9 2835",
    d: "M16.246,44.407c4.91.072,8.883,1.236,12.3,3.981a12.986,12.986,0,0,1,4.975,8.223,12.748,12.748,0,0,1,.133,1.767,1.317,1.317,0,0,1-1.226,1.362,1.347,1.347,0,0,1-1.458-1.224c-.066-.573-.055-1.158-.16-1.721a10.525,10.525,0,0,0-4.544-6.766,16.05,16.05,0,0,0-10.552-2.858,15.571,15.571,0,0,0-8.284,2.821,10.614,10.614,0,0,0-4.593,6.783,15.625,15.625,0,0,0-.151,1.638A1.411,1.411,0,0,1,1.7,59.7a1.3,1.3,0,0,1-1.474-.556A1.8,1.8,0,0,1,0,58.272a11.948,11.948,0,0,1,3.006-7.836,16.914,16.914,0,0,1,10.159-5.66c1.2-.224,2.428-.294,3.082-.369",
    transform: "translate(0 -20.986)",
    fill: "#99e7ff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon2);
export default __webpack_public_path__ + "static/media/user-icon-2.eed3162bf7e9a7e2c1a2d4f4c5999cd3.svg";
export { ForwardRef as ReactComponent };